import type { ExamId } from "./types";

/** 3 câu mỗi cấp, độ khó tăng dần — đủ để định vị trình độ trong ~10 phút. */
export const DIAGNOSTIC_IDS: Record<ExamId, string[]> = {
  "ccao-f": ["ao-p1", "ao-e2", "ao-g4"],
  "ccdv-f": ["dv-a4", "dv-t1", "dv-m2"],
  "ccar-f": ["af-cg1", "af-re1", "af-ex1"],
  "ccar-p": ["ap-d3", "ap-g1", "ap-m2"],
};

